var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 30,
    fill: "none",
    viewBox: "0 0 28 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#323338",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.819,
    d: "M2.325 7.884H25.57M6.974 14.554h13.948M10.46 21.225h6.975"
  })));
};
export default SvgFilter;